/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "accounts-management",
	data() {
		return {
			creditAccounts: [],
			customers: [],
			paymentTypes: [],
			accountHeadings: [
				{
					text: "Customer",
					field: "companyName"
				},
				{
					text: "Customer Term",
					field: "paymentTypeName"
				},
				{
					text: "Limit",
					field: "creditLimitAsString"
				},
				{
					text: "Credits Available",
					field: "currentBalanceAsString"
				}
			],
			pagingDetails: {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys: {
				suspend: "suspend"
			},
			suspendModal: {
				showModal: false,
				loading: false,
				modalId: "suspendCompanyModal",
				title: "Suspend Customer",
				message: "Are you sure you want to suspend this customer? This action will prevent them from placing new orders.",
				selectedCompanyId: null,
				selectedCompanyName: ""
			},
			filterStateChanged: false,
			filter: {
				selectedCustomerId: "",
				selectedPaymentTypeId: ""
			},
			loading: false
		};
	},
	methods: {
		getCompanyCreditAccounts() {
			this.loading = true;
			let request = {
				companyId: this.filter.selectedCustomerId || null,
				paymentTypeId: this.filter.selectedPaymentTypeId || null,
				pageNum: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			
			customerCreditsService.getCompanyCreditAccounts(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
						successResponse.data.responseStatus, 
						successResponse.data.httpStatusCode, 
						successResponse.data.message
					);
					if (isSuccess) {
						this.creditAccounts = successResponse.data.result || [];
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo?.thisPage || 1;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo?.totalPages || 1;
						
						// Add actions to each account
						for (let i = 0; i < this.creditAccounts.length; i++) {
                            this.creditAccounts[i].creditLimitAsString = currencyHelper.numberToCurrency(this.creditAccounts[i].creditLimit);
                            this.creditAccounts[i].currentBalanceAsString = currencyHelper.numberToCurrency(this.creditAccounts[i].currentBalance);
							this.creditAccounts[i].actions = [
								{
									name: "Suspend Customer",
									key: this.actionKeys.suspend,
									elementId: "btnSuspendCustomer",
									cssClass: "btn-outline-warning"
								}
							];
						}
					}
                    this.filterStateChanged = false;
					this.loading = false;
				}
			).catch(error => {
				console.error("Error fetching credit accounts:", error);
				this.loading = false;
                this.filterStateChanged = false;
			});
		},
		
		getCustomers() {
			let request = {
				searchQuery: "",
				isActive: true,
				pageNumber: 1,
				pageSize: 1000, // Get all customers for dropdown
				isCollectionCompany: true,
				isDeliveryCompany: true,
				isExTankCompany: true
			};
			
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
						successResponse.data.responseStatus, 
						successResponse.data.httpStatusCode, 
						successResponse.data.message
					);
					if (isSuccess) {
						this.customers = successResponse.data.result || [];
					}
				}
			).catch(error => {
				console.error("Error fetching customers:", error);
			});
		},
		
		getPaymentTypes() {
			systemService.getPaymentTypes().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
						successResponse.data.responseStatus, 
						successResponse.data.httpStatusCode, 
						successResponse.data.message
					);
					if (isSuccess) {
						this.paymentTypes = successResponse.data.result || [];
					}
				}
			).catch(error => {
				console.error("Error fetching payment types:", error);
			});
		},
		
		onAccountActionClicked(actionData) {
            console.log("Action clicked:", actionData);
			if (actionData.action === this.actionKeys.suspend) {
				this.suspendModal.selectedCompanyId = actionData.data.companyId;
				this.suspendModal.selectedCompanyName = actionData.data.companyName;
				this.suspendModal.message = `Are you sure you want to suspend "${actionData.data.companyName}"? This action will prevent them from placing new orders.`;
				this.suspendModal.showModal = true;
			}
		},
		
		onSuspendConfirmed(confirmed) {
			if (confirmed) {
				this.suspendModal.loading = true;
				let request = {
					companyId: this.suspendModal.selectedCompanyId
				};
				
				customerService.suspendCompany(request).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
							successResponse.data.responseStatus, 
							successResponse.data.httpStatusCode, 
							successResponse.data.message
						);
						if (isSuccess) {
							this.getCompanyCreditAccounts(); // Refresh the data
						}
						this.suspendModal.loading = false;
						this.suspendModal.showModal = false;
					}
				).catch(error => {
					console.error("Error suspending company:", error);
					this.suspendModal.loading = false;
					this.suspendModal.showModal = false;
				});
			} else {
				this.suspendModal.showModal = false;
			}
		},
		
		onPagingUpdated(pagingData) {
			this.pagingDetails.pageNumber = pagingData.pageNumber;
			this.pagingDetails.pageSize = pagingData.pageSize;
			this.getCompanyCreditAccounts();
		},
		
		onFilterSearchClicked() {
			this.pagingDetails.pageNumber = 1; // Reset to first page when filtering
			this.getCompanyCreditAccounts();
		},
		
		refreshAccounts() {
			this.getCompanyCreditAccounts();
		},
		
		navigateToSuspendedCustomers() {
			this.$router.push('/accounts/suspended');
		},

        downloadCompanyCreditAccounts(){
            this.loading = true;
            let request = {
                companyId: this.filter.selectedCustomerId || null,
                paymentTypeId: this.filter.selectedPaymentTypeId || null,
                pageNumber: this.pagingDetails.pageNumber,
                pageSize: this.pagingDetails.pageSize
            };
            customerCreditsService.downloadCompanyCreditAccounts(request).then(
                successResponse => {
                    const url = window.URL.createObjectURL(new Blob([successResponse.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'CompanyCreditAccounts.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.filterStateChanged = false;
                    this.loading = false;
                }
            ).catch(error => {
                console.error("Error fetching suspended customers:", error);
                this.loading = false;
                this.filterStateChanged = false;
            });
        },
		
        setBreadcrumbs() {
            storeState.setPageTitleAction("Accounts");
            breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Accounts");
        }
	},
	
	watch: {
		'filter.selectedCustomerId': function() {
			this.filterStateChanged = !this.filterStateChanged;
		},
		'filter.selectedPaymentTypeId': function() {
			this.filterStateChanged = !this.filterStateChanged;
		}
	},
	
	mounted: function () {
		this.getCustomers();
		this.getPaymentTypes();
		this.getCompanyCreditAccounts();
        this.setBreadcrumbs();
	}
};